<template>
  <div class="py-4 container-fluid">
    <!-- Statistics Cards -->
    <div class="row">
      <!-- <div
        class="col-xl-3 col-sm-6 mb-4"
        v-for="stat in stats"
        :key="stat.title"
      >
        <mini-statistics-card
          :title="stat.title"
          :value="stat.value"
          :percentage="stat.percentage"
          :icon="stat.icon"
          direction-reverse
        />
      </div> -->

      <div class="col-xl-3 col-sm-6 mb-4">
        <mini-statistics-card
          v-if="api_data"
          :title="'Todays Patients'"
          :value="api_data.todays_patients ? api_data.todays_patients : 0"
          :percentage="{ value: '+8%', color: 'text-success' }"
          :icon="{
            component: 'ni ni-single-02',
            background: 'bg-gradient-primary',
          }"
          direction-reverse
        />
      </div>

      <div class="col-xl-3 col-sm-6 mb-4">
        <mini-statistics-card
          v-if="api_data"
          :title="'Active Admissions'"
          :value="api_data.active_admissions ? api_data.active_admissions : 0"
          :percentage="{ value: '+2%', color: 'text-success' }"
          :icon="{
            component: 'ni ni-hotel',
            background: 'bg-gradient-info',
          }"
          direction-reverse
        />
      </div>

      <div class="col-xl-3 col-sm-6 mb-4">
        <mini-statistics-card
          v-if="api_data"
          :title="'Pending Lab Tests'"
          :value="api_data.pending_lab_tests ? api_data.pending_lab_tests : 0"
          :percentage="{ value: '-5%', color: 'text-danger' }"
          :icon="{
            component: 'ni ni-lab',
            background: 'bg-gradient-danger',
          }"
          direction-reverse
        />
      </div>
      <div class="col-xl-3 col-sm-6 mb-4">
        <mini-statistics-card
          v-if="api_data"
          :title="'Revenue Today'"
          :value="
            api_data.revenue_today
              ? 'Sh. ' + formatWithSuffix(api_data.revenue_today)
              : 0
          "
          :percentage="{ value: '+4%', color: 'text-success' }"
          :icon="{
            component: 'ni ni-money-coins',
            background: 'bg-gradient-warning',
          }"
          direction-reverse
        />
      </div>

      <!--  -->
    </div>

    <!-- Charts -->
    <div class="row">
      <!-- Visits Trend Line Chart -->
      <div class="col-lg-7 mb-4">
        <gradient-line-chart
          v-if="api_data.visitsTrend"
          id="chart-line"
          title="Patient Visits Trend"
          description="Inpatients & Outpatients visits over the last 9 months"
          :chart="api_data.visitsTrend"
        />
      </div>

      <!-- Department Services Bar Chart -->
      <div class="col-lg-5 mb-4">
        <reports-bar-chart
          v-if="api_data.servicesByDept"
          id="chart-bar"
          title="Department Services"
          description="Number of services offered per department"
          :chart="api_data.servicesByDept"
          :items="
            getDepts(
              api_data.consultations,
              api_data.lab_tests,
              api_data.revenue,
              api_data.admissions
            )
          "
        />
      </div>
    </div>

    <!-- Operational Metrics & Timeline -->
    <div class="row mt-4">
      <!-- Hospital Operational Metrics -->
      <div class="col-lg-8 mb-4">
        <div class="card h-100">
          <div class="card-header pb-0">
            <h6>Hospital Operational Summary</h6>
            <p class="text-sm">Live operational data overview</p>
          </div>
          <div class="card-body px-0 pt-0">
            <ul class="list-group">
              <!-- <li
                v-for="item in operationalMetrics"
                :key="item.title"
                class="list-group-item d-flex justify-content-between align-items-center border-0 px-4"
              >
                <div class="d-flex align-items-center">
                  <div
                    :class="`icon icon-shape ${item.iconBackground} text-white text-center me-3`"
                  >
                    <i :class="item.icon"></i>
                  </div>
                  <div>
                    <h6 class="mb-0">{{ item.title }}</h6>
                    <p class="text-xs text-secondary mb-0">
                      {{ item.subtitle }}
                    </p>
                  </div>
                </div>
                <span class="badge bg-light text-dark">{{ item.value }}</span>
              </li> -->

              <li
                class="list-group-item d-flex justify-content-between align-items-center border-0 px-4"
              >
                <div class="d-flex align-items-center">
                  <div
                    class="icon icon-shape bg-gradient-primary text-white text-center me-3"
                  >
                    <i class="ni ni-hotel"></i>
                  </div>
                  <div>
                    <h6 class="mb-0">Bed Occupancy</h6>
                    <p class="text-xs text-secondary mb-0">
                      Occupied / Total Beds
                    </p>
                  </div>
                </div>
                <span class="badge bg-light text-dark"
                  >{{ api_data.bed_occupancy }} / --</span
                >
              </li>

              <li
                class="list-group-item d-flex justify-content-between align-items-center border-0 px-4"
              >
                <div class="d-flex align-items-center">
                  <div
                    class="icon icon-shape bg-gradient-success text-white text-center me-3"
                  >
                    <i class="ni ni-calendar-grid-58"></i>
                  </div>
                  <div>
                    <h6 class="mb-0">Available Appointments</h6>
                    <p class="text-xs text-secondary mb-0">
                      Across all clinics
                    </p>
                  </div>
                </div>
                <span class="badge bg-light text-dark">{{
                  api_data.available_appointments
                }}</span>
              </li>

              <li
                class="list-group-item d-flex justify-content-between align-items-center border-0 px-4"
              >
                <div class="d-flex align-items-center">
                  <div
                    class="icon icon-shape bg-gradient-danger text-white text-center me-3"
                  >
                    <i class="ni ni-caps-small"></i>
                  </div>
                  <div>
                    <h6 class="mb-0">Pharmacy Low Stock Items</h6>
                    <p class="text-xs text-secondary mb-0">
                      Items below reorder level
                    </p>
                  </div>
                </div>
                <span class="badge bg-light text-dark">{{
                  api_data.low_stock_items
                }}</span>
              </li>

              <li
                class="list-group-item d-flex justify-content-between align-items-center border-0 px-4"
              >
                <div class="d-flex align-items-center">
                  <div
                    class="icon icon-shape bg-gradient-warning text-white text-center me-3"
                  >
                    <i class="ni ni-user-run"></i>
                  </div>
                  <div>
                    <h6 class="mb-0">Pending Discharges</h6>
                    <p class="text-xs text-secondary mb-0">
                      Awaiting clearance
                    </p>
                  </div>
                </div>
                <span class="badge bg-light text-dark">{{
                  api_data.pending_discharges
                }}</span>
              </li>

              <li
                class="list-group-item d-flex justify-content-between align-items-center border-0 px-4"
              >
                <div class="d-flex align-items-center">
                  <div
                    class="icon icon-shape bg-gradient-info text-white text-center me-3"
                  >
                    <i class="ni ni-money-coins"></i>
                  </div>
                  <div>
                    <h6 class="mb-0">Open Insurance Claims</h6>
                    <p class="text-xs text-secondary mb-0">
                      Unprocessed requests
                    </p>
                  </div>
                </div>
                <span class="badge bg-light text-dark">{{
                  api_data.open_insurance_claims
                }}</span>
              </li>

              <!-- -------------------------------------------------------------------- -->
            </ul>
          </div>
        </div>
      </div>

      <!-- Recent Activities Timeline -->
      <!-- Pharmacy & Stock Overview -->
      <div class="col-lg-4">
        <div class="card h-100">
          <div class="card-header pb-0">
            <h6>📦 Pharmacy & Stock Overview</h6>
            <p class="text-sm">Inventory and dispensing stats</p>
          </div>
          <div class="card-body px-0 pt-0">
            <ul class="list-group">
              <li
                class="list-group-item d-flex justify-content-between align-items-center border-0 px-4"
              >
                <div>
                  <h6 class="mb-0">Top Dispensed Drugs</h6>
                  <p class="text-xs text-secondary mb-0">
                    Most requested today
                  </p>
                </div>
                <span class="bg-gradient-success text-white">
                  <span
                    v-for="drug in api_data.top_dispensed_drugs"
                    :key="drug.id"
                  >
                    {{ drug.item_name }},
                  </span>
                </span>
              </li>

              <li
                class="list-group-item d-flex justify-content-between align-items-center border-0 px-4"
              >
                <div>
                  <h6 class="mb-0">Low Stock Alerts</h6>
                  <p class="text-xs text-secondary mb-0">
                    Items under reorder level
                  </p>
                </div>
                <span class="badge bg-gradient-danger text-white">{{
                  api_data.low_stock_items
                }}</span>
              </li>

              <li
                class="list-group-item d-flex justify-content-between align-items-center border-0 px-4"
              >
                <div>
                  <h6 class="mb-0">Expired Drugs Summary</h6>
                  <p class="text-xs text-secondary mb-0">
                    Out of stock & expired
                  </p>
                </div>
                <span class="badge bg-gradient-warning text-white">{{
                  api_data.expired_drugs
                }}</span>
              </li>

              <li
                class="list-group-item d-flex justify-content-between align-items-center border-0 px-4"
              >
                <div>
                  <h6 class="mb-0">Drugs Issued Today</h6>
                  <p class="text-xs text-secondary mb-0">
                    Total dispensed so far
                  </p>
                </div>
                <span class="badge bg-gradient-info text-white">{{
                  api_data.drugs_issued_today
                }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
import ReportsBarChart from "@/examples/Charts/ReportsBarChart.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
// import TimelineList from "./components/TimelineList.vue";
// import TimelineItem from "./components/TimelineItem.vue";
import { generalApiRequest } from "../api/apiIndex";

import {
  faCoins,
  faStethoscope,
  faHeartbeat,
  faFileMedical,
} from "@fortawesome/free-solid-svg-icons";

export default {
  name: "dashboard-default",
  components: {
    MiniStatisticsCard,
    ReportsBarChart,
    GradientLineChart,
    // TimelineList,
    // TimelineItem,
  },
  data() {
    return {
      api_data: {},
    };
  },

  methods: {
    getDepts(consultations, lab_tests, revenue, admissions) {
      return [
        {
          icon: { color: "primary", component: faStethoscope },
          label: "Consultations",
          progress: {
            content: this.formatWithSuffix(consultations),
            percentage: 85,
          },
        },
        {
          icon: { color: "info", component: faHeartbeat },
          label: "Lab Tests",
          progress: {
            content: this.formatWithSuffix(lab_tests),
            percentage: 90,
          },
        },
        {
          icon: { color: "warning", component: faCoins },
          label: "Revenue",
          progress: {
            content: "Sh." + this.formatWithSuffix(revenue),
            percentage: 60,
          },
        },
        {
          icon: { color: "danger", component: faFileMedical },
          label: "Admissions",
          progress: {
            content: this.formatWithSuffix(admissions),
            percentage: 70,
          },
        },
      ];
    },

    formatWithSuffix(number) {
      if (number >= 1000000000) {
        return (number / 1000000000).toFixed(1).replace(/\.0$/, "") + "B";
      } else if (number >= 1000000) {
        return (number / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
      } else if (number >= 1000) {
        return (number / 1000).toFixed(1).replace(/\.0$/, "") + "k";
      } else {
        return number.toString();
      }
    },
    async getApiData() {
      const res = await generalApiRequest("home_dashboard_data", "get", {}, 1);
      // console.log(res);
      this.api_data = res.data;
      // console.log(res.data);
    },
  },
  mounted() {
    this.getApiData();
  },
};
</script>
